"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _draftJs = require("draft-js"),
    _RichTextEditor = require("../../../../../../../../RichTextEditor"),
    _CommentAssets = _interopRequireDefault(require("../../../../../../CommentAssets")),
    _Header = _interopRequireDefault(require("./Header")),
    _Content = _interopRequireDefault(require("./Content")),
    _Controls = _interopRequireDefault(require("./Controls"));

require("../styles/_editable-comment.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var EditableComment = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleUpdate = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l, m, n, o;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (b = d.props, c = b.updateComment, e = b.comment.commentId, f = b.toggleEditMode, g = b.editMode, h = d.state, i = h.editorState, j = h.assetIds, k = (0, _RichTextEditor.getContentState)(i), l = k.json, m = k.plainText, m.trim() && g) {
                a.next = 5;
                break;
              }

              return a.abrupt("return");

            case 5:
              return d.setState({
                busy: !0
              }), a.next = 8, c(e, {
                content: l,
                assetIds: j
              });

            case 8:
              if (n = a.sent, o = n.error, d.setState({
                busy: !1
              }), !o) {
                a.next = 13;
                break;
              }

              return a.abrupt("return");

            case 13:
              f({
                toggle: !1
              });

            case 14:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.handleCancel = function () {
      var a = d.props.toggleEditMode;
      a({
        toggle: !1
      });
    }, d.handleDelete = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              b = d.props, c = b.deleteComment, e = b.closePopover, f = b.comment.commentId, g = b.onDeleteComment, e(), c({
                commentId: f,
                onSuccess: g
              });

            case 3:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.handleUpdateContent = function (a) {
      return d.setState({
        editorState: a
      });
    }, d.handleFilesChange = function (a) {
      d.setState({
        assetIds: a
      });
    }, d.onToggleEditMode = function (a) {
      var b = a.toggle,
          c = d.props,
          e = c.toggleEditMode,
          f = c.comment.content;
      if (!b) return void e({
        toggle: b
      });

      var g = (0, _draftJs.convertFromRaw)(f),
          h = _draftJs.EditorState.createWithContent(g);

      d.setState({
        editorState: h
      }), e({
        toggle: b
      });
    }, d.state = {
      busy: !1,
      editorState: _draftJs.EditorState.createEmpty(),
      assetIds: a.comment.assetIds
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.comment,
          c = a.comment,
          d = c.commentId,
          e = c.content,
          f = a.onUpdateCheckbox,
          g = a.canResolveComment,
          h = a.createReply,
          i = a.editMode,
          j = a.isReadOnly,
          k = a.resourceOrganisationId,
          l = this.state,
          m = l.busy,
          n = l.editorState,
          o = l.assetIds,
          p = (0, _RichTextEditor.getContentState)(n),
          q = p.plainText,
          r = !!q.trim();
      return _react["default"].createElement("div", {
        className: "editable-comment"
      }, _react["default"].createElement("div", {
        className: "editable-comment__header-content-wrapper"
      }, _react["default"].createElement(_Header["default"], {
        comment: b,
        onUpdateCheckbox: f,
        canResolveComment: g
      }), _react["default"].createElement(_Content["default"], {
        commentId: d,
        editMode: i,
        content: e,
        assetIds: o,
        editorState: n,
        onUpdateContent: this.handleUpdateContent,
        onSave: this.handleUpdate,
        onCancel: this.handleCancel,
        onFilesChange: this.handleFilesChange,
        resourceOrganisationId: k
      }), !i && o ? _react["default"].createElement(_CommentAssets["default"], {
        assetIds: o,
        commentId: d,
        onFilesChange: this.handleFilesChange
      }) : null), _react["default"].createElement(_Controls["default"], {
        editMode: i,
        busy: m,
        comment: b,
        createReply: h,
        toggleEditMode: this.onToggleEditMode,
        handleUpdate: this.handleUpdate,
        handleDelete: this.handleDelete,
        canSave: r,
        isReadOnly: j,
        resourceOrganisationId: k
      }));
    }
  }]), b;
}(_react.Component),
    _default = EditableComment;

exports["default"] = _default;